import React, { useContext } from "react";
import { LanguageContext } from "../../App";
import LanguageSelector from "../../components/LanguageSelector/LanguageSelector";
import homeLocalization from "../../localization/HomeLocalization";
import "./Home.scss";
import logo from "../../assets/logos/logo_transparent.svg";

function Home() {
    const { language } = useContext(LanguageContext);
    const text = homeLocalization[language] || homeLocalization["en"];

    return (
        <div className="home-container">
            <div className="stars"></div>
            <div className="content">
                <img src={logo} alt="Stellar Imperiums Logo" className="logo" />
                <h1>{text.title}</h1>
                <p><strong>{text.release}</strong></p>
                <LanguageSelector />
            </div>
            <footer className="footer">
                <p>
                    {text.footer} <strong><a href="https://studio.synarion.com" target="_blank" rel="noopener noreferrer">{text.studio}</a></strong>,&nbsp; 
                    {text.publishedBy} <strong><a href="https://www.synarion.com" target="_blank" rel="noopener noreferrer">{text.publisher}</a></strong>.
                </p>
            </footer>
        </div>
    );
}

export default Home;
